import type {
  DynamicPageContext,
  LinkBlock,
  LinkBlockItem,
  LinkBlockItemModel,
  ModelPageInfoBlocks,
} from '~/interfaces/api';
import HowToBuy from '~/components/ui/HowToBuy.vue';
import UiLink from '~/components/ui/ui-link/ui-link.vue';
import ProductsWithFilters from '@/components/listings/products-with-filters/ProductsWithFilters.vue';
import numWord from '~/common/num-word';

const ModelHistory = defineAsyncComponent(
  () => import('~/components/model-history/ModelHistory.vue')
);

export default defineComponent({
  name: 'BrandOffers',
  components: {
    UiLink,
    HowToBuy,
    ProductsWithFilters,
    ModelHistory,
  },
  props: {
    data: {
      type: Object as () => DynamicPageContext,
      required: true,
    },
    pageData: {
      type: Object as () => LinkBlockItemModel,
      required: true,
    },
  },
  setup(props) {
    const count = ref(props.pageData?.total);
    const popularBrands = ref<LinkBlockItem[]>([]);
    const blocks: ModelPageInfoBlocks = props.data.blocks || [];
    blocks.forEach((b) => {
      if (b.label === 'preset') popularBrands.value = (<LinkBlock>b).items;
    });
    const tabletCount = computed<string>(() => {
      return numWord(
        count.value,
        ['', 'товар', 'товара', 'товаров'],
        true,
        true,
        true
      );
    });
    const clearMobileScroll = () => {
      document.body.classList.remove('tablet-overflow-hidden');
      document.body.style.paddingRight = '';
    };
    return {
      count,
      popularBrands,
      clearMobileScroll,
      tabletCount,
    };
  },
});
